import { createRequiredContext } from '../createRequiredContext';
const { useContext, Provider, Context, Consumer } = createRequiredContext('CurrencyFormatter');
export const CurrencyFormatterProvider = Provider;
export const CurrencyFormatterConsumer = Consumer;
export const CurrencyFormatterContext = Context;
export const useCurrencyFormatter = useContext;
//# sourceMappingURL=CurrencyFormatterProvider.js.map